import { store } from '../index';
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { Textarea } from "@mui/joy";
import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import { nrf_registration } from "../utils/customer_helper";

import logo from "../assets/images/cyntra_logo.svg";
import { TOKEN_KEY } from "../utils/constant";

const RegistrationForm = () => {
  let user = store.getState().sessionReducer || {};
  const { store_id } = user;

  const [thanku, setThanku] = useState(false);
  const [img, setImg] = useState("");
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    phone_no: "",
    company_name: "",
    city: "",
    file: null,
    interested: "",
    note: "",
  });

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file);
    setFormData({ ...formData, file: file });
  };

  const postData = async () => {
    const _formData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "file" && formData.file) {
        _formData.append(key, formData.file);
      } else {
        _formData.append(key, formData[key]);
      }
    });

    _formData.append("store_id", store_id);

    for (let pair of _formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    try {
      const response = await nrf_registration(_formData);
      if (response) {
        console.log("API Response:", response);
        setThanku(true);
      }
    } catch (error) {
      console.error("Error while submitting the form:", error);
    }
  };

  const handleSubmit = () => {
    postData();
    console.log("Form Submitted:", formData);
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "0 auto",
        minHeight: "100vh",
        justifyContent: "center",
      }}
    >
      <Grid container style={{ padding: "2rem", justifyContent: "center" }}>
        {thanku ? (
          <Grid
            container
            style={{
                flexDirection:"column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5rem",
            }}
          >
            <Typography
              variant="h3"
              style={{ fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              Thank You !
            </Typography>
            <Button
                  onClick={() => setThanku(false)+
                    setFormData({  first_name: "",
                        last_name: "",
                        email_id: "",
                        phone_no: "",
                        company_name: "",
                        city: "",
                        file: null,
                        interested: "",
                        note: "",})
                  }
                  style={{
                    background: "#1976d2",
                    color: "white",
                    marginTop: "2rem",
                    minWidth: "100px",
                  }}
                  variant="contained"
                  type="submit"
                >
                  Start
                </Button>
          </Grid>
        ) : (
          <>
            <img alt="logo" width={"50%"} src={logo} />
            <Typography
              variant="h3"
              style={{ fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              Registration Form
            </Typography>
            <Grid container style={{ marginTop: "2rem" }}>
              <div style={{ minWidth: "100%" }}>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      First Name:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Last Name:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      email Id:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="email"
                      name="email_id"
                      value={formData.email_id}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      phone No:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="tel"
                      name="phone_no"
                      value={formData.phone_no}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Company:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="text"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      City:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <TextField
                      fullWidth
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                    ></TextField>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Photo:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <Button
                      style={{ background: "#1976d2", color: "white" }}
                      component="label"
                      role={undefined}
                      variant="contained"
                      tabIndex={-1}
                      startIcon={<CloudUploadIcon />}
                    >
                      Camera
                      <VisuallyHiddenInput
                        type="file"
                        name="file"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}
                      />
                    </Button>
                    <Typography ><span style={{fontSize:"0.9rem"}}>
                        {formData?.file?.name}</span></Typography>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Interested:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="interested"
                        size="small"
                        value={formData.interested}
                        onChange={handleInputChange}
                      >
                        <MenuItem value="Breez">Breez</MenuItem>
                        <MenuItem value="Leap">Leap</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                >
                  <Grid xs={4} sm={4} md={4} lg={4}>
                    <Typography
                      style={{ textAlign: "left", fontWeight: "600" }}
                    >
                      Note:
                    </Typography>
                  </Grid>
                  <Grid xs={8} sm={8} md={8} lg={8}>
                    <Textarea
                      minRows={2}
                      name="note"
                      value={formData.note}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>

                <Button
                  onClick={() => handleSubmit()}
                  style={{
                    background: "#1976d2",
                    color: "white",
                    marginTop: "2rem",
                    minWidth: "100px",
                  }}
                  variant="contained"
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default RegistrationForm;
